import { ref, inject, provide } from 'vue'
import { FORM_ITEM_VALIDATE } from '../../../tokens/index'

export function useFormItemValidateProvide() {
  const formItemRef = ref(null)
  const formItemsChange = () => {
    formItemRef.value?.onFieldChange()
  }

  provide(FORM_ITEM_VALIDATE, {
    formItemsChange,
  })
  return {
    formItemRef,
    formItemsChange,
  }
}

export function useFormItemValidate() {
  const { formItemsChange } = inject(FORM_ITEM_VALIDATE, { formItemsChange() {} })

  return {
    formItemsChange,
  }
}
